import { styled as muiStyled, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StyledTypography = muiStyled(Typography)({
  fontSize: '18px',
  color: NEW_COLORS.GRAYSCALE[700],
  lineHeight: '170%',
});

export { StyledTypography };
